<script>
import TabVertical from 'comp/content/TabVertical'
import Title2Logo from '../common/Title2Logo.vue'

import { richTextImgHandler } from '@/utils/common'
import { getCommunitySubPage } from '@/api/pageData'

export default {
  name: 'DialogId2',
  components: { TabVertical, Title2Logo },
  props: {
    titleid: {
      type: Number,
      default: 0
    },
    currentModuleItemDataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      path: this.$route.path,
      pageData: [],
      tabActive: 0,
      currentMemo: {},
      currentCommunity: localStorage.getItem('currentCommunity') || ''
    }
  },
  computed: {
    pageDataFilter2Tab() {
      let arr = []
      if (this.pageData) {
        this.pageData.forEach(item => arr.push({ id: item.id, title: item.headline, post: item.post }))
      }
      return arr
    }
  },
  watch: {
    currentMemo(newVal) {
      this.$nextTick(() => {
        setTimeout(() => {
          const parent = document.querySelector('.dialog-content-main')
          parent.scrollTo({ top: 0, behavior: 'smooth' })
        }, 200)
      })
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    richTextImgHandler,
    onTabClick(id) {
      this.pageData.forEach((item, idx) => {
        if (item.id === id) {
          this.tabActive = idx
          this.currentMemo = item
        }
      })
    },

    initPageData() {
      getCommunitySubPage({ titleid: Number(this.titleid), village: this.currentCommunity }).then(res => {
        if (res.code === 0) {
          this.pageData = res.msg || []
          // this.currentMemo = this.pageData[0]
          this.pageData.length > 0 && this.pageData.forEach((item, idx) => {
            if (item.id === this.currentModuleItemDataId) {
              this.tabActive = idx
              this.currentMemo = item
            }
          })
        }
      })
    }
  }
}
</script>

<template>
  <div class="dialog-id-2">
    <div class="title-box">
      <p class="module-title">基本情况</p>
      <el-image :src="require('imgs/modules/dialog-modules/title-logo-r.png')" class="title-logo-r" />
    </div>
    <div class="main-container">
      <div class="left-container">
        <title2-logo :headline="currentMemo.headline" />
        <p v-if="currentMemo.createtime" class="time">{{ currentMemo.createtime | formatDate('yyyy-MM-dd') }}</p>
        <p class="rich-text" v-html="richTextImgHandler(currentMemo.memo)"></p>
      </div>
      <div class="right-container">
        <tab-vertical
          :page-data="pageDataFilter2Tab"
          :tab-active="tabActive"
          :has-img="false"
          @onTabClick="onTabClick"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// 1330
// .dialog-id-2 {
//   display: flex;
// }
.title-box {
  display: flex;
  .title-logo-r {
    width: 75px;
    height: 30px;
    margin-top: 6px;
  }
}
.module-title {
  width: 162px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-family: siyuansong;
  font-weight: 800;
  color: #000;
  background: url('~imgs/community-intro/title-bg.png') no-repeat center;
  background-size: 100% 100%;
}
.main-container {
  display: flex;
  position: relative;
  margin-top: 60px;
  height: 570px;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
.left-container {
  width: 710px;
  // margin-left: 440px;
  margin-left: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .time {
    font-size: 14px;
    font-weight: bold;
    color: #B3B3B3;
    margin-top: 20px;
  }
  .rich-text {
    width: 710px;
    margin-top: 30px;
  }
}
.right-container {
  position: fixed;
  margin-left: 910px;
}
</style>
